import {ICartPosition} from "@connox/typescript-library";
import * as React from "react";
import {useTranslation} from "react-i18next";

interface IItemPriceProps {
  position: ICartPosition;
}

const ItemPrice: React.FC<IItemPriceProps> = (props) => {
  const {amount, amountRetail} = props.position;
  const {t} = useTranslation("cart");
  const whitespaceWrapping = (str: string) => str.replace(/\s/g, "\u00A0");

  if (amountRetail) {
    return (
      <React.Fragment>
        <span style={{textDecoration: "line-through"}}>
          {t("UVP\u00A0{{price}}", {price: whitespaceWrapping(amountRetail.formatted)})}
        </span>{" "}
        <strong style={{color: "red"}}>{whitespaceWrapping(amount.formatted)}</strong>
      </React.Fragment>
    );
  }

  return <strong>{amount.amount === "0.00" ? t("gratis") : amount.formatted}</strong>;

  // TODO Grundpreise sobald die API das hergibt (falls überhaupt noch nötig).
  // Code von Staege als Referenz für Markup:
  /*
 {itm.baseprice !== undefined &&
            [
                <br/>,
                <span style={{whiteSpace: "nowrap"}}>
                {
                    `(${itm.baseprice.value.toLocaleString("de-DE")} ${itm.amount.currencyCode}/` +
                    (itm.baseprice.unit > 1 && itm.baseprice.unit) +
                    `${itm.baseprice.unitName})`
                }
                </span>,
            ]
        }
         */
  // return <strong>{amount.formatted}</strong>;
};

export default ItemPrice;
